import { z } from "zod";
import DOMPurify from "dompurify";
import type { Translations } from "@/lib/i18n/types";

export function stripBuildingMarkup(value: string) {
  const fragment = DOMPurify.sanitize(value, {
    ALLOWED_TAGS: [],
    ALLOWED_ATTR: [],
    RETURN_DOM_FRAGMENT: true,
  });
  return fragment.textContent ?? "";
}

export function createBuildingSchema(t: Translations) {
  return z.object({
    name: z
      .string()
      .transform((value) => stripBuildingMarkup(value).trim())
      .pipe(
        z
          .string()
          .min(1, t.buildings.nameRequired)
          .min(2, t.forms.validation.minLength.replace("{min}", "2"))
      ),
    address: z
      .string()
      .transform((value) => stripBuildingMarkup(value).trim())
      .pipe(
        z
          .string()
          .min(1, t.buildings.addressRequired)
          .min(5, t.forms.validation.minLength.replace("{min}", "5"))
      ),
    registry_code: z
      .string()
      .default("")
      .refine((value) => !value || /^[0-9]{9}$/.test(value), {
        message: t.buildings.registryCodeInvalid,
      }),
  });
}

export type BuildingCreationValues = z.infer<ReturnType<typeof createBuildingSchema>>;
